const GLOBAL_HELP_PATHS = new Set([
  '/about-scrambl',
  '/delete-account',
  '/desktop-settings',
  '/settings',
  '/settings/mcp',
  '/settings/ticket-types',
  '/whats-new',
])

function getPathname(path: string) {
  return path.split(/[?#]/, 1)[0]
}

export function isGlobalHelpAppPath(path: string) {
  const pathname = getPathname(path)
  return (
    pathname === '/help' ||
    pathname.startsWith('/help/') ||
    GLOBAL_HELP_PATHS.has(pathname)
  )
}

export function resolveHelpAppPath(orgSlug: string | undefined, path: string) {
  if (!orgSlug || !path) return path
  if (/^(?:[a-z][a-z\d+.-]*:|\/\/)/i.test(path) || path.startsWith('#')) {
    return path
  }

  const normalized = path.startsWith('/') ? path : `/${path}`
  if (isGlobalHelpAppPath(normalized)) return normalized
  if (
    normalized === `/${orgSlug}` ||
    normalized.startsWith(`/${orgSlug}/`) ||
    normalized.startsWith(`/${orgSlug}?`) ||
    normalized.startsWith(`/${orgSlug}#`)
  ) {
    return normalized
  }

  return `/${orgSlug}${normalized}`
}

export function rewriteHelpArticleHtmlLinks(
  html: string,
  orgSlug: string | undefined,
) {
  if (!orgSlug) return html

  return html.replace(
    /(<a\b[^>]*?\shref=)(["'])([^"']+)(["'])/gi,
    (match, prefix, openQuote, href, closeQuote) => {
      const rewritten = resolveHelpAppPath(orgSlug, href)
      if (rewritten === href) return match
      return `${prefix}${openQuote}${rewritten}${closeQuote}`
    },
  )
}
